/**
 * Route Configuration Helpers
 * Reduces duplication in route configs
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('routeHelpers', routeHelpers);

    routeHelpers.$inject = ['lazyLoadSvc'];

    function routeHelpers(lazyLoadSvc) {
        var service = {
            // Lazy load helper
            lazyLoad: createLazyLoader,

            // Translation helper
            loadTranslations: loadTranslations,

            // Language protection helpers
            langProtect: langProtectResolve,
            langProtectTwoPath: langProtectTwoPathResolve,

            // Common resolves
            resolves: {
                hasPackage: hasPackageResolve,
                guardRole: guardRoleResolve,
                langProtect: langProtectResolve,
                langProtectTwoPath: langProtectTwoPathResolve
            }
        };

        return service;

        ////////////////

        /**
         * Create a lazy loader function for routes
         * @param {string|array} bundles - Bundle name(s) to load
         * @param {object} options - Additional options
         */
        function createLazyLoader(bundles, options) {
            return function($transition$) {
                return lazyLoadSvc.load($transition$, bundles, options);
            };
        }

        /**
         * Load translation parts
         * @param {string|array} parts - Translation part name(s)
         */
        function loadTranslations(parts) {
            if (typeof parts === 'string') {
                parts = [parts];
            }

            return ['$translatePartialLoader', '$translate', function($translatePartialLoader, $translate) {
                parts.forEach(function(part) {
                    $translatePartialLoader.addPart(part);
                });
                return $translate.refresh();
            }];
        }

        /**
         * Check if user has package
         */
        function hasPackageResolve() {
            return ['guardSvc', function(guardSvc) {
                return guardSvc.hasPackage();
            }];
        }

        /**
         * Guard route by role
         * @param {array} roles - Allowed role IDs
         */
        function guardRoleResolve(roles) {
            return ['guardSvc', function(guardSvc) {
                return guardSvc.guardRouteRole(roles);
            }];
        }

        /**
         * Language path protection (redirects to correct lang path)
         * For simple single-path routes
         * @param {string} stateNameKey - Optional translation key, defaults to state name
         */
        function langProtectResolve(stateNameKey) {
            return ['$transition$', '$translate', '$rootScope', '$timeout',
                function($transition$, $translate, $rootScope, $timeout) {
                    var path = $transition$.params().path;
                    var lang = $transition$.params().langcode;
                    var device = $transition$.params().device;

                    return $translate(stateNameKey || $transition$.to().name, {}, undefined, undefined, lang)
                        .then(function(translation) {
                            if (path !== translation) {
                                $timeout(function() {
                                    $rootScope.MetaTags.prerender.statusCode = 301;
                                    var newParams = { path: translation, langcode: lang };
                                    if (device !== undefined) {
                                        newParams.device = device;
                                    }
                                    var newUrl = $transition$.router.stateService.href(
                                        $transition$.to().name,
                                        angular.extend({}, $transition$.params(), newParams)
                                    );
                                    window.redirected = "Location: " + newUrl;
                                    $rootScope.MetaTags.prerender.header = window.redirected;
                                }, 0);

                                $transition$.abort();

                                var params = { path: translation, langcode: lang };
                                if (device !== undefined) {
                                    params.device = device;
                                }

                                $transition$.router.stateService.go(
                                    $transition$.to().name,
                                    angular.extend({}, $transition$.params(), params)
                                );
                            }
                        });
                }];
        }

        /**
         * Language path protection for nested states with two paths
         * For routes like: /services/automated-valuation (path + path2)
         */
        function langProtectTwoPathResolve() {
            return ['$transition$', '$translate', function($transition$, $translate) {
                var path = $transition$.params().path;
                var path2 = $transition$.params().path2;
                var lang = $transition$.params().langcode;
                var ad = $transition$.params().ad;
                var promo = $transition$.params().promo;

                // Check first path (parent state)
                return $translate($transition$.to().name.split('.')[0], {}, undefined, undefined, lang)
                    .then(function(translation) {
                        var redirect = 0;
                        if (path !== translation) {
                            path = translation;
                            redirect = 1;
                        }

                        // Check second path (child state)
                        return $translate($transition$.to().name.split('.')[1], {}, undefined, undefined, lang)
                            .then(function(translation2) {
                                if (path2 !== translation2) {
                                    path2 = translation2;
                                    redirect = 1;
                                }

                                if (redirect) {
                                    $transition$.abort();

                                    var params = {
                                        path: path,
                                        path2: path2,
                                        langcode: lang
                                    };

                                    // Preserve optional params
                                    if (ad !== undefined) params.ad = ad;
                                    if (promo !== undefined) params.promo = promo;

                                    $transition$.router.stateService.go(
                                        $transition$.to().name,
                                        params
                                    );
                                }
                            });
                    });
            }];
        }
    }
})();
